/** Next actions panel section for TodayViewPanels. */
import { Box, Collapse } from '@mui/material';
import Panel from '@/components/ui/Panel';
import { getOnboardingHighlightSx } from '@/features/onboarding/utils/onboardingHighlightSx';
import TodaySectionList from './TodaySectionList';
import {
  TODAY_PANEL_A11Y,
  TODAY_PANEL_FLAT_CLASS,
} from './todayViewPanelsHelpers';

export function TodayNextActionsPanelSection({
  t,
  isBattlefield,
  showNextAction,
  todayEmpty,
  nextActionHintActive,
  displayNextActions,
  nextActions,
  topActionableTaskId,
  tasksMap,
  selectedTaskIds,
  setSelectedTaskIds,
}) {
  return (
    <Collapse in={showNextAction} timeout={220} unmountOnExit>
      <Box sx={getOnboardingHighlightSx(nextActionHintActive)}>
        <Panel
          flat
          contentClassName={TODAY_PANEL_FLAT_CLASS}
          title={t('todayviewcontent.nextActions', 'Next Actions')}
          count={displayNextActions.length}
          defaultOpen={todayEmpty}
          forceOpen={nextActionHintActive}
          testId="panel-next-actions"
          {...TODAY_PANEL_A11Y}
        >
          <TodaySectionList
            isBattlefield={isBattlefield}
            variant="sortable"
            tasks={displayNextActions}
            totalTasksCount={nextActions?.length || 0}
            listId="mobile-next-actions-list"
            taskType="next-action"
            topActionableTaskId={topActionableTaskId}
            showPlayButtonAlways
            tasksMap={tasksMap}
            inProgressMessage={t(
              'todayviewcontent.nextActionInProgress',
              'Your next action is in progress!',
            )}
            emptyMessage={t(
              'todayviewcontent.nextActionsEmpty',
              'No next actions available.',
            )}
            selectedTaskIds={selectedTaskIds}
            onSelectionChange={setSelectedTaskIds}
          />
        </Panel>
      </Box>
    </Collapse>
  );
}
